// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/_molecules/CopyText/styles.css
// module id = 554
// module chunks = 0